
jQuery(document).ready(function(){
  jQuery('.corporate-gift-list').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  });
})

document.addEventListener("DOMContentLoaded", () => {
  const counters = document.querySelectorAll(".counter");
  let started = false;

  function animateCounter(counter) {
    const from = parseInt(counter.getAttribute("data-from")) || 0;
    const to = parseInt(counter.getAttribute("data-to")) || 0;
    const duration = 4000; // 4 seconds total
    const totalSteps = Math.abs(to - from);
    if (totalSteps === 0) return;

    const stepTime = Math.max(10, Math.floor(duration / totalSteps));
    let current = from;
    const increment = to > from ? 1 : -1;

    const timer = setInterval(() => {
      current += increment;
      counter.textContent = current;
      if (current === to) clearInterval(timer);
    }, stepTime);
  }

  function handleScroll() {
    const section = document.querySelector(".home-counter-section");
    if (!section) return;

    const sectionTop = section.getBoundingClientRect().top;
    const triggerPoint = window.innerHeight - 100;

    if (!started && sectionTop < triggerPoint) {
      counters.forEach(counter => animateCounter(counter));
      started = true;
    }
  }

  window.addEventListener("scroll", handleScroll);
  handleScroll(); // in case already visible
});
